exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1QrxffCGj_UH2IsG8TUWT1{top:48px;bottom:0;position:fixed;z-index:2}html[dir] ._1QrxffCGj_UH2IsG8TUWT1{background:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._1QrxffCGj_UH2IsG8TUWT1,html[dir=rtl] ._1QrxffCGj_UH2IsG8TUWT1{left:0;right:0}", ""]);
// Exports
exports.locals = {
	"SxSView": "_1QrxffCGj_UH2IsG8TUWT1"
};